import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { AngieScreensService } from '@services/angie-screens/angie-screens.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';
import { RedirectService } from '@services/redirects/redirect.service';
import { JsonService } from '@services/jsons/json.service';
import { ScreenSettingsService } from '@services/screen-settings/screen-settings.service';
import { CodeSnippetService } from '@services/code-snippets/code-snippet.service';
import { DialogService } from '@services/dialog/dialog.service';
import { DataTableComponent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'app-angie-screen-detail',
    templateUrl: './angie-screen-detail.component.html',
    styleUrls: ['./angie-screen-detail.component.scss'],
    providers: [AngieScreensService, OrganisationCustomerService, RedirectService, JsonService, ScreenSettingsService, CodeSnippetService],
    standalone: false
})
export class AngieScreenDetailComponent implements OnInit {

  @ViewChild(DataTableComponent) jsonTable: DataTableComponent;

  public pageActions: PageAction[];
  public title = 'Angie Screen: ';
  public urlBase;
  public isLoading = true;
  public screen: Models.AngieScreen;
  public redirects: Models.Redirect[];
  public screenId: string;
  public organisationCustomer;

  public jsonDataProviderParams: any;
  public jsonDataTableColumns = [
    { prop: 'language' }
  ];

  public redirectDataTableColumns = [
    { prop: 'title' }
  ];

  constructor(
    private angieScreensService: AngieScreensService,
    private organisationCustomerService: OrganisationCustomerService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private activatedRoute: ActivatedRoute,
    private snackbar: SnackbarService,
    private router: Router,
    private redirectService: RedirectService,
    public jsonService: JsonService,
    private dialogService: DialogService,
  ) {
  }

  ngOnInit() {
    this.screenId = this.activatedRoute.snapshot.params['id'];

    this.angieScreensService.get(this.screenId).then(response => {
      this.screen = response;
      this.title += this.screen.name;
      this.jsonDataProviderParams = {
        screenUUID: this.screen.uuid
      };
      this.urlBase = 'https://my.ibexfusion.com/app/launch/' + this.screen.uuid;
      this.fetchOrganisationCustomer();
      this.fetchAngieCustomer();
      this.fetchRedirects();
      this.isLoading = false;
      this.createPageActions();
    });
  }

  navigateToRedirect(event: any) {
    this.router.navigate(['redirects', event.row.getId()]);
  }

  navigateToJsonEdit(event: any) {
    this.router.navigate(['jsons', event.row.getId(), 'edit']);
  }

  navigateToJsonDetail(event: any) {
    this.router.navigate(['jsons', event.row.getId(), 'detail']);
  }

  removeJson(event: any) {
    this.dialogService
      .confirm('Remove Json?')
      .then(res => {
        if (!res) {
          return;
        }

        return this.jsonService.remove(event.row._id).then(() => {
          this.snackbar.success('Json removed', 3000);
          this.jsonTable.refresh();
        }).catch(error => {
          const message = (error.error.message ? error.error.message : error.message);
          return this.dialogService.confirm(message, error.name);
        });
      });
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'edit',
        title: 'Edit screen',
        callback: () => {
          this.router.navigate(['angie-screens', this.screenId, 'edit']);
        }
      }),
      new PageAction({
        icon: 'person',
        title: 'Customer',
        callback: () => {
          if (!this.screen.organisationCustomerId) {
            this.snackbar.open('There is no customer assigned to this screen');
            return;
          }
          this.router.navigate(['organisation-customers', this.screen.organisationCustomerId]);
        }
      }),
      new PageAction({
        icon: 'settings',
        title: 'Open Screen Settings',
        callback: () => {
          this.router.navigate(['screen-settings', this.screen.uuid]);
        }
      }),
      new PageAction({
        icon: 'transform',
        title: 'Add Redirect',
        callback: () => {
          this.router.navigate(['redirects/create', this.screen.uuid]);
        }
      }),
      new PageAction({
        icon: 'receipt',
        title: 'Device Logs',
        callback: () => {
          this.router.navigate(['device-health/', this.screen.uuid]);
        }
      }),
      new PageAction({
        icon: 'add',
        title: 'Add Custom JSON',
        callback: () => {
          this.router.navigate(['jsons', this.screen.uuid]);
        }
      })
    ];
  }

  private fetchOrganisationCustomer() {
    if (this.screen && this.screen.organisationCustomerId) {
      this.organisationCustomerService.find(0, 1, { _id: this.screen.organisationCustomerId }).then(organisationCustomer => {
        if (organisationCustomer.data && organisationCustomer.data.length) {
          this.organisationCustomer = organisationCustomer.data[0].organisationName;
          return;
        }
      })
    }
  }

  private fetchAngieCustomer() {
    if (this.screen && this.screen.customerId) {
      // todo fetch angie-customer
    }
  };

  private fetchRedirects() {
    this.redirectService.find(0, 100, { screenUUID: this.screen.uuid }).then(responseRedirect => {
      this.redirects = responseRedirect.data;
    });
  }

}
